import { useState, useRef } from "react";
import { api_path } from "../../shared.js";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
const STATUS_ICONS = {
  "Empty Container Release to Shipper": "📦",
  "Gate In": "🚪",
  "Gate Out": "🚪",
  "Loaded on Vessel": "🚢",
  "Vessel Departure": "⚓",
  "Vessel Arrival": "🏁",
  "Unloaded": "📤",
  "Delivery": "🏠",
  "Empty Container Returned": "✅",
};

function getIcon(status) {
  for (const [key, icon] of Object.entries(STATUS_ICONS)) {
    if (status.toLowerCase().includes(key.toLowerCase())) return icon;
  }
  return "📍";
}

function formatDate(str) {
  if (!str) return "—";
  const d = new Date(str);
  if (isNaN(d)) return str;
  return d.toLocaleString("th-TH", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export  function ShipmentTracking() {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [activeTab, setActiveTab] = useState("timeline");
  const [activeContainer, setActiveContainer] = useState(0);
  const inputRef = useRef();

  async function handleSearch(e) {
    e?.preventDefault();
    const q = query.trim();
    if (!q) return;

    setLoading(true);
    setError("");
    setResult(null);
    setActiveContainer(0);
    setActiveTab("timeline");

    try {
      const res = await fetch(`${api_path}/tracking/shipment-tracking.php?q=${encodeURIComponent(q)}`);
      const data = await res.json();
      if (data.status === "success" && data.data) {
        setResult(data.data);
      } else {
        setError(data.message || "ไม่พบข้อมูล");
      }
    } catch {
      setError("ไม่สามารถเชื่อมต่อ server ได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      setLoading(false);
    }
  }

  function handleSample(val) {
    setQuery(val);
    setTimeout(() => handleSearch(), 0);
  }

  const container = result?.containers?.[activeContainer];

  return (
       <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <br />
        </Grid>
                <Grid item xs={12} sm={12}>
    <div style={styles.page}>



      {/* ─── Search ─── */}
      <div style={styles.searchWrap}>
        <form onSubmit={handleSearch} style={styles.searchForm}>
          <div style={styles.searchBox}>
            <span style={styles.searchIcon}>🔍</span>
            <input
              ref={inputRef}
              style={styles.searchInput}
              type="text"
              placeholder="กรอก Booking No หรือ Container No..."
              value={query}
              onChange={e => setQuery(e.target.value)}
            />
            <button type="submit" style={styles.searchBtn} disabled={loading}>
              {loading ? <Spinner /> : "ค้นหา"}
            </button>
          </div>
        </form>
        <div style={styles.sampleRow}>
          <span style={styles.sampleLabel}>ตัวอย่าง:</span>
          {["BKKGB2654900", "ONEU0754115"].map(s => (
            <button key={s} style={styles.sampleChip} onClick={() => handleSample(s)}>{s}</button>
          ))}
        </div>
      </div>

      {/* ─── Error ─── */}
      {error && (
        <div style={styles.errorBox}>
          <span>⚠️</span> {error}
        </div>
      )}

      {/* ─── Result ─── */}
      {result && (
        <div style={styles.resultWrap}>

          {/* Booking Header Card */}
          <div style={styles.bookingCard}>
            <div style={styles.bookingTop}>
              <div>
                <div style={styles.bookingNo}>{result.booking_no}</div>
                <div style={styles.bookingCarrier}>Carrier: {result.carrier}</div>
              </div>
              <div style={styles.badgeRow}>
                <span style={{ ...styles.badge, ...styles.badgeBlue }}>{result.booking_Type || result.booking_type}</span>
                <span style={{ ...styles.badge, ...styles.badgeGreen }}>
                  {result.containers?.[0]?.status}
                </span>
              </div>
            </div>
            <div style={styles.metaGrid}>
              <MetaItem label="Ref Job ID" value={result.ref_jobid} small />
              <MetaItem label="จำนวน Container" value={`${result.containers?.length} container`} />
            </div>
          </div>

          {/* Container Tabs (if multiple) */}
          {result.containers?.length > 1 && (
            <div style={styles.contTabs}>
              {result.containers.map((c, i) => (
                <button
                  key={i}
                  style={{ ...styles.contTab, ...(i === activeContainer ? styles.contTabActive : {}) }}
                  onClick={() => setActiveContainer(i)}
                >
                  📦 {c.container_no}
                </button>
              ))}
            </div>
          )}

          {/* Container Block */}
          {container && (
            <div style={styles.contBlock}>
              <div style={styles.contHeader}>
                <span style={styles.contNo}>📦 {container.container_no}</span>
                <span style={{ ...styles.badge, ...(container.status === "Success" ? styles.badgeGreen : styles.badgeAmber) }}>
                  {container.status}
                </span>
              </div>

              {/* View Tabs */}
              <div style={styles.viewTabs}>
                {["timeline", "table"].map(t => (
                  <button
                    key={t}
                    style={{ ...styles.viewTab, ...(activeTab === t ? styles.viewTabActive : {}) }}
                    onClick={() => setActiveTab(t)}
                  >
                    {t === "timeline" ? "🕐 Timeline" : "📋 ตาราง"}
                  </button>
                ))}
              </div>

              {/* Timeline View */}
              {activeTab === "timeline" && (
                <div style={styles.timeline}>
                  {container.container_status?.map((cs, i) => {
                    const isActual = cs.tracking_status_type === "Actual";
                    const isLast = i === container.container_status.length - 1;
                    return (
                      <div key={i} style={styles.tlRow}>
                        <div style={styles.tlLeft}>
                          <div style={{ ...styles.tlDot, ...(isActual ? styles.tlDotActual : styles.tlDotEst) }} />
                          {!isLast && <div style={{ ...styles.tlLine, ...(isActual ? styles.tlLineActual : styles.tlLineEst) }} />}
                        </div>
                        <div style={styles.tlContent}>
                          <div style={{ ...styles.tlStatus, ...(!isActual ? styles.tlStatusEst : {}) }}>
                            {getIcon(cs.tracking_status)} {cs.tracking_status}
                          </div>
                          <div style={styles.tlMeta}>
                            <span>🕐 {formatDate(cs.status_date)}</span>
                            <span>📍 {cs.location}</span>
                            <span style={{ ...styles.typeBadge, ...(isActual ? styles.typeBadgeActual : styles.typeBadgeEst) }}>
                              {cs.tracking_status_type}
                            </span>
                          </div>
                          {cs.sino_status_code && (
                            <div style={styles.sinoTag}>
                              {cs.sino_status_code} · {cs.sino_status_name}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Table View */}
              {activeTab === "table" && (
                <div style={styles.tableWrap}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        {["วันที่/เวลา", "สถานะ", "SINO Code", "สถานที่", "ประเภท"].map(h => (
                          <th key={h} style={styles.th}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {container.container_status?.map((cs, i) => {
                        const isActual = cs.tracking_status_type === "Actual";
                        return (
                          <tr key={i} style={i % 2 === 0 ? styles.trEven : {}}>
                            <td style={styles.td}><span style={styles.dateCell}>{formatDate(cs.status_date)}</span></td>
                            <td style={styles.td}>{cs.tracking_status}</td>
                            <td style={styles.td}>
                              {cs.sino_status_code
                                ? <span style={styles.sinoTag}>{cs.sino_status_code}</span>
                                : <span style={styles.dash}>—</span>}
                            </td>
                            <td style={styles.td}>{cs.location}</td>
                            <td style={styles.td}>
                              <span style={{ ...styles.typeBadge, ...(isActual ? styles.typeBadgeActual : styles.typeBadgeEst) }}>
                                {cs.tracking_status_type}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ─── Empty state ─── */}
      {!result && !error && !loading && (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🚢</div>
          <div style={styles.emptyText}>กรอก Booking No หรือ Container No เพื่อตรวจสอบสถานะ</div>
        </div>
      )}
    </div>
    </Grid>
    </Grid>
    </Container>
  );
}

function MetaItem({ label, value, small }) {
  return (
    <div>
      <div style={styles.metaLabel}>{label}</div>
      <div style={{ ...styles.metaValue, ...(small ? { fontSize: 11, wordBreak: "break-all" } : {}) }}>{value || "—"}</div>
    </div>
  );
}

function Spinner() {
  return (
    <span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid #fff", borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </span>
  );
}

const styles = {
  page: { fontFamily: "'DM Sans', 'Noto Sans Thai', sans-serif", minHeight: "100vh", background: "#F0F4FA", color: "#1a2235" },

  header: { background: "#0B2545", padding: "1.5rem 0 1.25rem", marginBottom: 0 },
  headerInner: { maxWidth: 780, margin: "0 auto", padding: "0 1.5rem" },
  logo: { display: "flex", alignItems: "center", gap: 10, marginBottom: 4 },
  logoIcon: { fontSize: 22, lineHeight: 1 },
  logoText: { fontSize: 20, fontWeight: 700, color: "#fff", letterSpacing: "-0.3px" },
  headerSub: { fontSize: 13, color: "#8BAFD4", margin: 0 },

  searchWrap: { background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "1.25rem 1.5rem", maxWidth: "100%" },
  searchForm: { maxWidth: 780, margin: "0 auto" },
  searchBox: { display: "flex", alignItems: "center", border: "1.5px solid #CBD5E1", borderRadius: 10, overflow: "hidden", background: "#fff", transition: "border-color 0.2s" },
  searchIcon: { padding: "0 12px", fontSize: 16, color: "#94A3B8" },
  searchInput: { flex: 1, border: "none", outline: "none", fontSize: 15, padding: "11px 0", background: "transparent", color: "#1a2235", fontFamily: "inherit" },
  searchBtn: { background: "#185FA5", color: "#fff", border: "none", padding: "0 22px", height: 44, fontSize: 14, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" },
  sampleRow: { maxWidth: 780, margin: "10px auto 0", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  sampleLabel: { fontSize: 12, color: "#94A3B8" },
  sampleChip: { fontSize: 12, padding: "3px 12px", borderRadius: 99, border: "1px solid #CBD5E1", background: "#F8FAFC", color: "#475569", cursor: "pointer", fontFamily: "inherit" },

  errorBox: { maxWidth: 780, margin: "1rem auto", padding: "12px 16px", background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, color: "#B91C1C", fontSize: 14, display: "flex", gap: 8, alignItems: "center" },

  resultWrap: { maxWidth: 780, margin: "1.5rem auto", padding: "0 1.5rem 3rem" },

  bookingCard: { background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, padding: "1.25rem 1.5rem", marginBottom: "1.25rem" },
  bookingTop: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" },
  bookingNo: { fontSize: 20, fontWeight: 700, color: "#0B2545", letterSpacing: "-0.3px" },
  bookingCarrier: { fontSize: 13, color: "#64748B", marginTop: 2 },
  badgeRow: { display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "flex-end" },
  badge: { fontSize: 12, padding: "3px 10px", borderRadius: 6, fontWeight: 600 },
  badgeBlue: { background: "#EFF6FF", color: "#1D4ED8" },
  badgeGreen: { background: "#F0FDF4", color: "#15803D" },
  badgeAmber: { background: "#FFFBEB", color: "#B45309" },

  metaGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 12, paddingTop: "0.875rem", borderTop: "1px solid #F1F5F9" },
  metaLabel: { fontSize: 11, color: "#94A3B8", marginBottom: 2, textTransform: "uppercase", letterSpacing: "0.4px" },
  metaValue: { fontSize: 13, fontWeight: 500, color: "#334155" },

  contTabs: { display: "flex", gap: 8, marginBottom: "1rem", flexWrap: "wrap" },
  contTab: { padding: "6px 14px", borderRadius: 8, border: "1px solid #E2E8F0", background: "#fff", fontSize: 13, color: "#64748B", cursor: "pointer", fontFamily: "inherit" },
  contTabActive: { background: "#0B2545", color: "#fff", borderColor: "#0B2545" },

  contBlock: { background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, padding: "1.25rem 1.5rem" },
  contHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" },
  contNo: { fontSize: 15, fontWeight: 600, color: "#0B2545" },

  viewTabs: { display: "flex", gap: 0, borderBottom: "1px solid #E2E8F0", marginBottom: "1.5rem" },
  viewTab: { padding: "8px 18px", fontSize: 13, cursor: "pointer", color: "#64748B", background: "none", border: "none", borderBottom: "2px solid transparent", fontFamily: "inherit", fontWeight: 500 },
  viewTabActive: { color: "#185FA5", borderBottomColor: "#185FA5" },

  timeline: { paddingLeft: 0 },
  tlRow: { display: "flex", gap: 0, marginBottom: 0 },
  tlLeft: { display: "flex", flexDirection: "column", alignItems: "center", width: 28, flexShrink: 0 },
  tlDot: { width: 12, height: 12, borderRadius: "50%", flexShrink: 0, marginTop: 3, border: "2px solid #CBD5E1", background: "#fff", zIndex: 1 },
  tlDotActual: { background: "#185FA5", borderColor: "#185FA5" },
  tlDotEst: { background: "#fff", borderColor: "#94A3B8" },
  tlLine: { flex: 1, width: 1, minHeight: 24 },
  tlLineActual: { background: "#BFDBFE" },
  tlLineEst: { background: "#E2E8F0" },
  tlContent: { paddingBottom: "1.25rem", flex: 1, paddingLeft: 8 },
  tlStatus: { fontSize: 14, fontWeight: 600, color: "#1E293B", marginBottom: 4 },
  tlStatusEst: { color: "#94A3B8", fontWeight: 500 },
  tlMeta: { fontSize: 12, color: "#64748B", display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 4 },
  typeBadge: { fontSize: 11, padding: "1px 7px", borderRadius: 4, fontWeight: 600 },
  typeBadgeActual: { background: "#DBEAFE", color: "#1D4ED8" },
  typeBadgeEst: { background: "#F1F5F9", color: "#64748B" },
  sinoTag: { display: "inline-block", fontSize: 11, background: "#EFF6FF", color: "#1D4ED8", padding: "2px 8px", borderRadius: 4, marginTop: 2 },

  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: { textAlign: "left", fontWeight: 600, fontSize: 11, color: "#64748B", padding: "8px 10px", borderBottom: "1px solid #E2E8F0", background: "#F8FAFC", textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" },
  td: { padding: "9px 10px", borderBottom: "1px solid #F1F5F9", color: "#334155", verticalAlign: "top" },
  trEven: { background: "#FAFAFA" },
  dateCell: { whiteSpace: "nowrap" },
  dash: { color: "#CBD5E1" },

  emptyState: { textAlign: "center", padding: "4rem 1.5rem" },
  emptyIcon: { fontSize: 48, marginBottom: "1rem" },
  emptyText: { fontSize: 15, color: "#94A3B8" },
};
